var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08246 12.6202C9.18816 12.0945 9.40446 11.5973 9.71702 11.1616C10.0296 10.7259 10.4312 10.3616 10.8953 10.093C11.3594 9.82432 11.8753 9.65746 12.4088 9.60345C12.9423 9.54945 13.4812 9.60953 13.9897 9.77971C14.4983 9.9499 14.9648 10.2263 15.3583 10.5905C15.7518 10.9548 16.0634 11.3986 16.2723 11.8924C16.4812 12.3863 16.5827 12.919 16.57 13.455C16.5573 13.9911 16.4308 14.5184 16.1987 15.0018C15.6479 16.7388 13.3226 17.9711 12.9208 20.111C12.5189 22.2509 8.55725 22.3609 8.79334 19.3073",
    stroke: "#1F2F3D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7709 13.2927C14.7709 13.2927 15.0567 11.2778 13.1998 11.2778C11.3428 11.2778 11.6526 14.5586 9.91846 14.5586",
    stroke: "#1F2F3D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9808 6.85938C14.6094 6.85937 16.1713 7.50633 17.3229 8.65793C18.4745 9.80953 19.1215 11.3714 19.1215 13M10.6813 16.6865C10.6813 16.6865 10.0366 16.7903 10.0366 17.8034C10.0366 18.8164 12.2167 18.7243 12.2167 17.1582C12.2167 15.592 10.4496 14.7933 11.3829 13.2054L10.6813 16.6865Z",
    stroke: "#1F2F3D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9756 3.84717C14.1774 3.84717 15.3675 4.08389 16.4778 4.54381C17.5882 5.00373 18.5971 5.67785 19.4469 6.52767C20.2967 7.3775 20.9708 8.38638 21.4308 9.49673C21.8907 10.6071 22.1274 11.7971 22.1274 12.999",
    stroke: "#1F2F3D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#1F2F3D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListening);
export default __webpack_public_path__ + "static/media/listening.992b3d33bcf5b453f6b0165045cb52ee.svg";
export { ForwardRef as ReactComponent };